import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map, switchMap } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { AssetForm } from "app/interfaces/asset-form.interface";
import { Observable } from "rxjs";

const assetsUrlApi = environment.assetsUrlApi;
const assetsGetUrlApi = environment.assetsGetUrlApi;
const assetsPostUrlApi = environment.assetsPostUrlApi;
const assetsOwnUrlApi = environment.assetsOwnUrlApi;
const assetsExtensionsListUrlApi = environment.assetsExtensionsListUrlApi;

@Injectable()
export class AssetService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  uploadAsset(
    idIncident,
    id,
    file: File,
    assetModel: AssetForm
  ): Observable<any> {
    if (!assetModel.user_id) {
      assetModel.user_id = id;
    }
    const formData = new FormData();
    formData.append("asset_uploaded", file, file.name);
    formData.append("user_id", String(assetModel.user_id));
    formData.append("title", assetModel.title);
    formData.append("description", assetModel.description);
    formData.append("id_incident", idIncident);
    return this.http.post(environment.assetsUrlApi, formData);
  }

  getAssets() {
    return this.http
      .request("GET", `${assetsGetUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getOwnerIncidentAssets(id: number) {
    return this.http
      .request("GET", `${assetsOwnUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getAssetById(id: number) {
    return this.http
      .request("GET", `${assetsUrlApi}/` + id, { responseType: "blob" })
      .pipe(switchMap((response) => this.readFile(response)));
  }

  getAssetExtensionAvailable() {
    return this.http
      .request("GET", `${assetsExtensionsListUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  private readFile(blob: Blob): Observable<string> {
    return Observable.create((obs) => {
      const reader = new FileReader();
      reader.onerror = (err) => obs.error(err);
      reader.onabort = (err) => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();
      return reader.readAsDataURL(blob);
    });
  }

  updateAssetById(id: number, assetModel: AssetForm) {
    console.log(id);
    console.log(assetModel);
    const body = assetModel;
    return this.http
      .request("PUT", `${assetsUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteAssetById(id: number) {
    return this.http
      .request("DELETE", `${assetsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
